const articles_navigation = $('.articleNavigationLink');

articles_navigation.on('click', function(e) {
    e.preventDefault();
    scrollTo($(this).attr('href'));
});

$('.article-item .show').on('click', function() {
    if($(this).hasClass('open')) {
        // $(this).closest('.article-item').find('.text').find('.show-text').show();
        $(this).closest('.article-item').find('.text').find('.hide-text').hide();
        $(this).removeClass('open');
    } else {
        // $(this).closest('.article-item').find('.text').find('.show-text').hide();
        $(this).closest('.article-item').find('.text').find('.hide-text').show();
        $(this).addClass('open');
    }
        // .parent('')
        // .parent()
        // .prev('div')
        // .toggleClass('hidden-text');
    // $(this).hide();
    //$(this).parent().prev('p').find('video').trigger('play');
});

// superpanel article galleries
const articles = $('.article-item');

if (articles.length > 0) {
    let key = 0;
    $(articles).each(function() {
        const $class = '.articleItemSlider--' + key;
        const $classNav = '.articleItemSliderNav--' + key;
        $($class).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: $classNav,
            adaptiveHeight: true,
        });

        $($classNav).slick({
            rows: 0,
            nextArrow:
                '<button type="button" class="slick-next"><span class="sr-only">Nastepny slajd</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 68.624 132.143" enable-background="new 0 0 68.624 132.143" xml:space="preserve"> <path fill-rule="evenodd" clip-rule="evenodd" class="initial initial--white" d="M59.42,69.179c-2.763,2.146-28.396,28.023-42.824,42.588 c-4.953,5-8.708,8.791-8.771,8.855c-0.078,0.077-0.836,0.81-1.667,1.611c-2.167,2.092-5.037,4.862-5.889,6.389 c-0.239,0.428-0.309,0.878-0.247,1.299c0.054,0.366,0.206,0.726,0.433,1.047c0.244,0.347,0.56,0.637,0.924,0.84 c0.488,0.272,1.086,0.398,1.738,0.303c1.224-0.18,9.054-8.375,13.353-12.874c1.213-1.269,2.204-2.307,2.485-2.587 c4.026-4.026,7.143-7.195,10.396-10.504c8.352-8.493,17.48-17.775,24.318-24.136c1.817-1.69,3.662-3.595,5.481-5.475 c1.277-1.318,2.546-2.628,3.124-3.207c0.507-0.507,1.207-1.142,1.938-1.806c2.022-1.839,4.396-3.996,4.411-5.503 c0.021-2.148-7.397-9.094-11.891-13.299c-1.357-1.271-2.521-2.359-2.804-2.643L19.352,15.5c-0.203-0.203-1.182-1.221-2.368-2.455 C12.676,8.564,4.779,0.351,3.288,0.049C2.758-0.059,2.215,0.017,1.72,0.223C1.284,0.406,0.896,0.692,0.592,1.047 C0.313,1.376,0.117,1.746,0.04,2.124c-0.077,0.377-0.037,0.81,0.155,1.269C0.56,4.265,4.234,7.831,6.417,9.95 c0.516,0.5,0.956,0.927,1.315,1.287c2.787,2.789,5.706,5.662,8.642,8.551c3.395,3.341,6.807,6.699,8.739,8.631l17.289,17.289 c1.272,1.272,2.67,2.605,4.265,4.125c4.952,4.722,11.572,11.035,13.6,14.06l2.04,3.044L59.42,69.179z"/> </svg></button>',
            prevArrow:
                '<button type="button" class="slick-prev"><span class="sr-only">Poprzedni slajd</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 68.624 132.143" enable-background="new 0 0 68.624 132.143" xml:space="preserve"> <path fill-rule="evenodd" clip-rule="evenodd" class="initial initial--white" d="M9.203,69.179c2.763,2.146,28.397,28.023,42.825,42.588 c4.953,5,8.708,8.791,8.771,8.855c0.077,0.077,0.836,0.81,1.667,1.611c2.167,2.092,5.037,4.862,5.889,6.389 c0.239,0.428,0.309,0.878,0.247,1.299c-0.055,0.366-0.206,0.726-0.433,1.047c-0.244,0.347-0.561,0.637-0.924,0.84 c-0.489,0.272-1.086,0.398-1.738,0.303c-1.223-0.18-9.054-8.375-13.354-12.874c-1.212-1.269-2.203-2.307-2.484-2.587 c-4.026-4.026-7.143-7.195-10.396-10.504c-8.352-8.493-17.48-17.775-24.318-24.136c-1.818-1.69-3.662-3.595-5.482-5.475 c-1.277-1.318-2.545-2.628-3.124-3.207c-0.507-0.507-1.207-1.142-1.938-1.806C2.389,69.684,0.015,67.526,0,66.02 c-0.021-2.148,7.398-9.094,11.891-13.299c1.357-1.271,2.52-2.359,2.804-2.643L49.272,15.5c0.203-0.203,1.182-1.221,2.368-2.455 C55.948,8.564,63.846,0.351,65.336,0.049c0.53-0.107,1.073-0.032,1.568,0.174c0.436,0.183,0.824,0.469,1.128,0.824 c0.28,0.329,0.476,0.698,0.553,1.076c0.076,0.377,0.036,0.81-0.155,1.269c-0.365,0.872-4.04,4.438-6.223,6.557 c-0.516,0.5-0.955,0.927-1.315,1.287c-2.787,2.789-5.706,5.662-8.642,8.551c-3.395,3.341-6.807,6.699-8.739,8.631L26.223,45.707 c-1.272,1.272-2.67,2.605-4.265,4.125c-4.952,4.722-11.572,11.035-13.6,14.06l-2.041,3.044L9.203,69.179z"/> </svg> </button>',
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: $class,
            dots: false,
            centerMode: false,
            focusOnSelect: true
            // autoplay: true,
            // autoplaySpeed: 5000,
            // responsive: [
            //     {
            //         breakpoint: 1320,
            //         settings: {
            //           slidesToShow: 4,
            //         }
            //       } ,
            //     {
            //         breakpoint: 990,
            //         settings: {
            //           slidesToShow: 4,
            //         }
            //       } ,
            //     {
            //         breakpoint: 770,
            //         settings: {
            //           slidesToShow: 4,
            //         }
            //       } ,
            //     {
            //       breakpoint: 570,
            //       settings: {
            //         slidesToShow: 4,
            //       }
            //     }
            //   ]
        });
        key++;
    });
}

$('.sliderGalerySuper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: false,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    dots: true,
    mobileFirst: true,
    nextArrow:
        '<button type="button" class="slick-next"><span class="sr-only">Nastepny slajd</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 68.624 132.143" enable-background="new 0 0 68.624 132.143" xml:space="preserve"> <path fill-rule="evenodd" clip-rule="evenodd" class="initial initial--white" d="M59.42,69.179c-2.763,2.146-28.396,28.023-42.824,42.588 c-4.953,5-8.708,8.791-8.771,8.855c-0.078,0.077-0.836,0.81-1.667,1.611c-2.167,2.092-5.037,4.862-5.889,6.389 c-0.239,0.428-0.309,0.878-0.247,1.299c0.054,0.366,0.206,0.726,0.433,1.047c0.244,0.347,0.56,0.637,0.924,0.84 c0.488,0.272,1.086,0.398,1.738,0.303c1.224-0.18,9.054-8.375,13.353-12.874c1.213-1.269,2.204-2.307,2.485-2.587 c4.026-4.026,7.143-7.195,10.396-10.504c8.352-8.493,17.48-17.775,24.318-24.136c1.817-1.69,3.662-3.595,5.481-5.475 c1.277-1.318,2.546-2.628,3.124-3.207c0.507-0.507,1.207-1.142,1.938-1.806c2.022-1.839,4.396-3.996,4.411-5.503 c0.021-2.148-7.397-9.094-11.891-13.299c-1.357-1.271-2.521-2.359-2.804-2.643L19.352,15.5c-0.203-0.203-1.182-1.221-2.368-2.455 C12.676,8.564,4.779,0.351,3.288,0.049C2.758-0.059,2.215,0.017,1.72,0.223C1.284,0.406,0.896,0.692,0.592,1.047 C0.313,1.376,0.117,1.746,0.04,2.124c-0.077,0.377-0.037,0.81,0.155,1.269C0.56,4.265,4.234,7.831,6.417,9.95 c0.516,0.5,0.956,0.927,1.315,1.287c2.787,2.789,5.706,5.662,8.642,8.551c3.395,3.341,6.807,6.699,8.739,8.631l17.289,17.289 c1.272,1.272,2.67,2.605,4.265,4.125c4.952,4.722,11.572,11.035,13.6,14.06l2.04,3.044L59.42,69.179z"/> </svg></button>',
    prevArrow:
        '<button type="button" class="slick-prev"><span class="sr-only">Poprzedni slajd</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 68.624 132.143" enable-background="new 0 0 68.624 132.143" xml:space="preserve"> <path fill-rule="evenodd" clip-rule="evenodd" class="initial initial--white" d="M9.203,69.179c2.763,2.146,28.397,28.023,42.825,42.588 c4.953,5,8.708,8.791,8.771,8.855c0.077,0.077,0.836,0.81,1.667,1.611c2.167,2.092,5.037,4.862,5.889,6.389 c0.239,0.428,0.309,0.878,0.247,1.299c-0.055,0.366-0.206,0.726-0.433,1.047c-0.244,0.347-0.561,0.637-0.924,0.84 c-0.489,0.272-1.086,0.398-1.738,0.303c-1.223-0.18-9.054-8.375-13.354-12.874c-1.212-1.269-2.203-2.307-2.484-2.587 c-4.026-4.026-7.143-7.195-10.396-10.504c-8.352-8.493-17.48-17.775-24.318-24.136c-1.818-1.69-3.662-3.595-5.482-5.475 c-1.277-1.318-2.545-2.628-3.124-3.207c-0.507-0.507-1.207-1.142-1.938-1.806C2.389,69.684,0.015,67.526,0,66.02 c-0.021-2.148,7.398-9.094,11.891-13.299c1.357-1.271,2.52-2.359,2.804-2.643L49.272,15.5c0.203-0.203,1.182-1.221,2.368-2.455 C55.948,8.564,63.846,0.351,65.336,0.049c0.53-0.107,1.073-0.032,1.568,0.174c0.436,0.183,0.824,0.469,1.128,0.824 c0.28,0.329,0.476,0.698,0.553,1.076c0.076,0.377,0.036,0.81-0.155,1.269c-0.365,0.872-4.04,4.438-6.223,6.557 c-0.516,0.5-0.955,0.927-1.315,1.287c-2.787,2.789-5.706,5.662-8.642,8.551c-3.395,3.341-6.807,6.699-8.739,8.631L26.223,45.707 c-1.272,1.272-2.67,2.605-4.265,4.125c-4.952,4.722-11.572,11.035-13.6,14.06l-2.041,3.044L9.203,69.179z"/> </svg> </button>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 3
            }
        }
    ]
});

function scrollTo(_target) {
    if (!_target) return;
    $('html, body').animate(
        {
            scrollTop: $(_target).offset().top - 50
        },
        500
    );
}
